// Official DENSO YouTube videos featured in the Interactive Product Guide.
// Titles/descriptions sourced directly from the public YouTube video metadata.

export const YOUTUBE_VIDEOS = [
  {
    id: "paAP4pVaLj4",
    title: "DENSO Global Aftermarket Video",
    description:
      "DENSO Aftermarket brings Original Equipment parts to technicians and drivers all around the world.",
  },
  {
    id: "nvcJFkf_XJ0",
    title: "DENSO Spark Plugs: Genuine vs Fake",
    description: "How to spot the differences between counterfeit and genuine DENSO spark plugs.",
  },
  {
    id: "-ozfcDtrID4",
    title: "DENSO Spark Plug Heat Range",
    description: "Ask An Expert: understanding heat range when choosing the correct spark plug for your engine.",
  },
  {
    id: "6KCabK5oEUU",
    title: "Discover DENSO Spark Plug Technology",
    description: "DENSO's Iridium spark plugs deliver improved power, economy and emissions performance.",
  },
  {
    id: "aIPZ40txla8",
    title: "DENSO Wiper Blades",
    description: "First Time Fit Conventional, Designer and Beam style blades for OE fit and streak-free performance.",
  },
  {
    id: "pDkAD-AbAIc",
    title: "DENSO First Time Fit | Starters and Alternators",
    description: "Segment Conductor (SC) technology delivers increased power, reduced weight and improved efficiency.",
  },
];

export const getYoutubeEmbedUrl = (videoId) => `https://www.youtube.com/embed/${videoId}`;
